import script from "./TopShopPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopShopPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopShopPanel.vue?vue&type=style&index=0&id=220d635d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-220d635d"]])

export default __exports__